import React from 'react'

// using this component instead of Formik ErrorMessage in case, when we want show errors event if field has not been touched.
const CustomFormErrorMsg = ({show = false, className, message = 'Error'}) => {
  return show && <div className={className}>{message}</div>
}

export default CustomFormErrorMsg
